import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll: function (example, pageable) {
    let params = utils.merge(example, pageable);
    return httpService.get("tkTaskAssignView", {params: params});
  },
  findByIds(ids) {
    return httpService.get("tkTaskAssignView/findByIds/"+ ids);
  },
}



// WEBPACK FOOTER //
// ./src/services/tkTaskAssignViewService.js